"use client";

import {
  DEFAULT_QUANTITY_MAX_DECIMAL_PLACES,
  type QuantityInputPolicy,
  quantityStepForDecimalPlaces,
} from "@workspace/domain/quantities/quantity-precision";
import { createContext, useContext } from "react";

const DEFAULT_QUANTITY_INPUT_POLICY: QuantityInputPolicy = {
  version: 1,
  maxDecimalPlaces: DEFAULT_QUANTITY_MAX_DECIMAL_PLACES,
  inputStep: quantityStepForDecimalPlaces(DEFAULT_QUANTITY_MAX_DECIMAL_PLACES),
};

const QuantityPrecisionContext = createContext<QuantityInputPolicy>(
  DEFAULT_QUANTITY_INPUT_POLICY
);

export function QuantityPrecisionProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: QuantityInputPolicy;
}) {
  return (
    <QuantityPrecisionContext.Provider value={value}>
      {children}
    </QuantityPrecisionContext.Provider>
  );
}

export function useQuantityPrecision(): QuantityInputPolicy {
  return useContext(QuantityPrecisionContext);
}
